<div *ngIf="!isPrompt" class="dialog-main-container">
  <div class="d-flex justify-content-end" *ngIf="!isPrompt && displayCloseBtn">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>


  <mat-dialog-content class="dialog-content" [ngClass]="{'pt-0': displayCloseBtn}">
    <div class="modal-title d-flex justify-content-center header-bottom-class m-0 title-padding">
      <span>{{ title }}</span>
    </div>
    <img [src]='data.imgsrc' alt="">
    <p *ngIf="bodyText" class="bodyText text-center">{{ bodyText }}</p>
    <div class="checkbox-label" *ngIf="showCheckBox">
      <input class="checkbox-input" type="checkbox" [checked]="shouldLogoutAllDevice" (change)="toggleDeviceLogout()">
      <span class="checkbox-label-text">Require all devices to sign in with new password</span>
    </div>
  </mat-dialog-content>

  <div *ngIf="!isPrompt && showBtnGrp">
    <div class="d-flex justify-content-center align-items-center me-2 button-group">
      <button mat-raised-button class="primary-button me-2" color="primary" (click)="save()">
        {{ actionBtnText }}
      </button>
      <button mat-raised-button class="secondary-button" mat-dialog-close cdkFocusInitial>
        Cancel
      </button>
    </div>
  </div>
  <div *ngIf="!isPrompt && !showBtnGrp">
    <div class="d-flex justify-content-center align-items-center me-2">
      <button mat-raised-button class="primary-button dialog-singleBt" mat-dialog-close cdkFocusInitial
        (click)="close()">
        {{actionBtnText ? actionBtnText: 'Ok'}}
      </button>
    </div>
  </div>
</div>
<div *ngIf="isPrompt" class="feedback-prompt dialog-main-container">
  <img [src]="title === 'Error' ? 'assets/icons/Alert.svg':'assets/icons/success.svg' " alt="">
  <p>{{ bodyText }}</p>
</div>
